import type { QueryFilter } from '@/types';
import type { FlatGraphNode } from '@/types/FlatGraph';

import NodeLogicalToggleButton from './NodeLogicalToggleButton';

interface NodeFiltersHeaderProps {
  node: FlatGraphNode;
  filters: QueryFilter[];
  editable: boolean;
  onUpdateFilters?: (nodeId: string, filters: QueryFilter[]) => void;
  extractDisplayFilters: (filters: QueryFilter[]) => {
    displayFilters: QueryFilter[];
    currentOperator: 'AND' | 'OR' | null;
  };
  handleToggleOperator: (
    currentFilters: QueryFilter[],
    currentOperator: 'AND' | 'OR'
  ) => QueryFilter[];
}

/**
 * NodeFiltersHeader - Displays "Filters" heading with AND/OR toggle button
 * Toggle only visible when 2+ filters exist with an operator
 */
export const NodeFiltersHeader = ({
  node,
  filters,
  editable,
  onUpdateFilters,
  extractDisplayFilters,
  handleToggleOperator,
}: NodeFiltersHeaderProps) => {
  const { displayFilters, currentOperator } = extractDisplayFilters(filters);

  return (
    <div className="mb-2 flex items-center justify-between">
      <div className="text-chariot-text-primary text-sm font-medium">
        Filters
      </div>

      {/* AND/OR toggle (visible when 2+ filters) */}
      {displayFilters.length >= 2 && currentOperator && (
        <NodeLogicalToggleButton
          node={node}
          filters={filters}
          editable={editable}
          currentOperator={currentOperator}
          onUpdateFilters={onUpdateFilters}
          handleToggleOperator={handleToggleOperator}
        />
      )}
    </div>
  );
};
